import React from "react";

import { Button, Menu, Affix, } from "antd";

//import dom
import { Link } from "react-router-dom";
import moment from "moment";


const { SubMenu } = Menu;


export default class SubHeader extends React.Component {
  //RUN: เพิ่ม constructor 16/04/2021  
  constructor() {
    super();
    this.state = {
      language: localStorage.getItem("Language"),
      covidInfoStatus: localStorage.getItem("covidInfoStatus"),

    };
  }


  //RUN: เพิ่ม function เปลี่ยน ภาษา (อันนี้ใช้ชั่วคราว) 16/04/2021
  getTitleReportEval() {
    if (this.state.language == 'TH') {
      return "รายงาน"
    } else {
      return "Report"
    }
  }
  //RUN: เพิ่ม function เปลี่ยน ภาษา (อันนี้ใช้ชั่วคราว) 16/04/2021
  getTitleEval() {
    if (this.state.language == 'TH') {
      return "การประเมิน"
    } else {
      return "Evaluation"
    }
  }

  renderVacSubHeader() {
    return (
      <Menu
        mode="horizontal"
      >
        <Menu.Item>
          {this.state.language == 'TH' ?
            <Link to="/home"> หน้าหลัก </Link>
            :
            <Link to="/home"> Home </Link>
          }
        </Menu.Item>

        <Menu.Item>
          {this.state.covidInfoStatus == 0 ?

            this.state.language == 'TH' ?
              <Link to="/covid-add"> เพิ่มข้อมูล </Link>
              :
              <Link to="/covid-add"> Add </Link>
            :
            null
          }
          {this.state.covidInfoStatus == 1 ?

            this.state.language == 'TH' ?
              <Link to="/covid-update"> อัพเดทข้อมูล </Link>
              :
              <Link to="/covid-update"> Edit </Link>
            :
            null
          }
        </Menu.Item>
      </Menu>
    )
  }
  renderSubHeaderEva() {
    this.state.language = localStorage.getItem("Language")
    const evalutionStatus = localStorage.getItem("selfEvalStatus");
    return (
      <Menu
        mode="horizontal"
      >
        <Menu.Item>
          {this.state.language == 'TH' ?
            <Link to="/home"> หน้าหลัก </Link>
            :
            <Link to="/home"> Home </Link>
          }
        </Menu.Item>



        {evalutionStatus == '3' ?
          <SubMenu key="report" title={this.getTitleReportEval()}>
            <Menu.ItemGroup>
              <Menu.Item>
                {this.state.language == 'TH' ?

                  <Link to="/self-evalution-report">ผลการประเมินตนเอง</Link>
                  :
                  <Link to="/self-evalution-report">Self-Assessment Report</Link>

                }
              </Menu.Item>


              {/* <Menu.Item key="setting:4">ผลการพิจารณาระดับผลปฎิบัติงาน</Menu.Item>
    <Menu.Item key="setting:5">พิมพ์คะแนนประเมินผลงาน</Menu.Item>
    <Menu.Item key="setting:6">พิมพ์ผลการพิจารณาระดับผลการปฎิบัติงาน</Menu.Item> */}
            </Menu.ItemGroup>
          </SubMenu>

          :
          null}

        <SubMenu title={this.getTitleEval()}>

          <Menu.ItemGroup>
            {
              evalutionStatus != 3 ?

                   localStorage.getItem("selfEvalStatusBackState") == 0
                  ?
                  <Menu.Item disabled>
                    {this.state.language == 'TH' ?
                      <Link to="/self-evalution" >ประเมินตนเอง
                      {console.log('sonosnos',moment(localStorage.getItem("selfEvalEndDate")).format("llll"))}
                      {console.log('dnonww',moment(Date.now()).format('llll'))}
                      
                      </Link>
                      :
                      <Link to="/self-evalution" >Sef-Assessment</Link>
                    }
                  </Menu.Item>
                  :
                  <Menu.Item disabled>
                    {this.state.language == 'TH' ?
                      <Link to="/self-evalution">ประเมินตนเอง
                      {console.log('enddate',moment(localStorage.getItem("selfEvalEndDate")).format("llll"))}
                        {moment(localStorage.getItem("selfEvalStartDate")).format("llll")} -
                        {moment(localStorage.getItem("selfEvalEndDate")).format("llll")}
                      </Link>
                      :
                      <Link to="/self-evalution">Sef-Assessment {moment(localStorage.getItem("selfEvalEndDate")).format("DD/MM/YYYY")} -
                        {moment(localStorage.getItem("selfEvalEndDate")).format("llll")}
                      </Link>
                    }
                  </Menu.Item>
                : null
            }
            {/* disabled ไว้ก่อน 03/04/2022*/}

            {localStorage.getItem("HaveUnderEmpPrimary") == 1 ?
              <Menu.Item>
                {this.state.language == 'TH' ?
                  <Link to="/assessing-subordinate" >ประเมินผู้ใต้สังกัด</Link>
                  :
                  <Link to="/assessing-subordinate" >Assessing Subordinate</Link>
                }

              </Menu.Item>
              :
              null
            }


            {/* <Menu.Item key="setting:2">ประเมินผู้ใต้สังกัด</Menu.Item> */}
          </Menu.ItemGroup>
        </SubMenu>

        {localStorage.getItem("IsHRPrivilege") == '1' ?
          <Menu.Item key="foradmin">
            <Button type="link" style={{ color: "black" }}>
              {this.state.language == 'TH' ?

                <Link to="/for-admin"> Administrator </Link>
                :
                <Link to="/for-admin"> Administrator </Link>

              }
            </Button>
          </Menu.Item>
          : null
        }
      </Menu>
    );

  }

  render() {
    //RUN set ค่าให้ใหม่ เมื่อทำการ Render เพื่อdynamic การเปลี่ยนภาษาแบบทันที
    this.state.language = localStorage.getItem("Language")
    const evalutionStatus = localStorage.getItem("selfEvalStatus");
    return (
      <Affix offsetTop={85}>
        {/* home menu */}
        {window.location.pathname == '/vaccine-info' ?
          this.renderVacSubHeader() :
          this.renderSubHeaderEva()
        }
      </Affix>
    );
  }
}
